import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { roleGuard, SessionService } from "@kno2/core/session";
import { IntegrationsService } from "@kno2/data-access/integrations";
import { InteroperabilitySettings, SettingsService } from "@kno2/data-access/settings";

const interoperabilitySettingsResolver = async (): Promise<InteroperabilitySettings> => {
    const settingsService = inject(SettingsService);
    return await settingsService.getInteroperabilitySettingsAsync();
};

const useIntegrationDocumentTypes = async () => {
    const integrationsService = inject(IntegrationsService);
    const capabilities = await integrationsService.getCapabilitiesAsync();
    const useIntegrationDocumentTypes = capabilities?.capabilities?.find((c) => c.display === "documentTypeLookup")?.reference.includes("integrations");

    return useIntegrationDocumentTypes;
};

const brandSettingsResolver = async () => {
    const sessionService = inject(SessionService);
    const settingsService = inject(SettingsService);
    const profile = sessionService.profileData();

    const { data } = await settingsService.getBrandSettingsAsync(profile.brandId);

    return data;
};

export const routes: Routes = [
    {
        path: "intake",
        loadComponent: () => import("./intake.component").then((m) => m.IntakeComponent),
        canActivate: [roleGuard],
        data: {
            roles: ["Administrator", "User"],
            reuse: (previousUrl: string, state: Record<string, unknown>) => previousUrl.startsWith("/intake/") && !state["messageMutated"]
        }
    },
    {
        path: "intake/:id",
        loadComponent: () => import("./message/intake-message.component").then((m) => m.IntakeMessageComponent),
        resolve: {
            interoperabilitySettings: interoperabilitySettingsResolver,
            useIntegrationDocumentTypes: useIntegrationDocumentTypes,
            brandSettings: brandSettingsResolver
        },
        canActivate: [roleGuard],
        data: {
            roles: ["Administrator", "User"]
        }
    }
];
